import ajax from './ajax';
import {Toast, Modal} from 'antd-mobile';
import {langCheck} from 'src/hrzz/public/mobile/utils/utils'
import {getAuthExpiredMessage, notifyAppLogout} from './authExpired';

const showLoading = () => {
    Toast.loading(langCheck('hrzzmb-000001', false, null, "hrzzmb"), 0)
};

const hideLoading = () => {
    Toast.hide()
};

export default ({
                    data,
                    url,
                    loading,
                    headers,
                    info,
                    noNeedShowError = false, //判断是否抛错，默认需要
                    ...other
                }) => {
    !loading && showLoading();
    return new Promise((resolve, reject) => {
        ajax({
            url: url,
            method: 'post',
            data: data,
            info,
            headers,
            success: (res) => {
                console.log(res)
                hideLoading();
                resolve(res);
            },
            error: (err) => {
                console.log(err)
                hideLoading();
                // 提示
                const message = getAuthExpiredMessage(err, err.message || err.data.error.message);
                !noNeedShowError && Modal.alert(langCheck('hrzzmb-000002', false, null, "hrzzmb"), message, [
                    {text: langCheck('hrzzmb-000003', false, null, "hrzzmb"), onPress: () => notifyAppLogout(err)},
                ]);
                // 确定
                // Toast.fail(err.message||err.data.error.message);
                reject(err);
            },
            ...other
        });
    });
}
